export const POS_USER_TYPES = [
    { level: '4', name: 'Super User' },
    { level: '3', name: 'District Manager' },
    { level: '2', name: 'Store Manager' },
    { level: '1', name: 'Store Clerk' },
    { level: '0', name: 'Temp Clerk' },
];



// WEBPACK FOOTER //
// ./src/Fuse/User/posUserLists.js